import db from './indexDB'

export default {
    async addTraps(traps) {
        await db.traps.bulkPut(traps);
    },

    async addLocations(locations) {
        await db.trapLocations.bulkPut(locations);
    },

    async getLocations() {
        return await db.trapLocations.toArray();
    },

    async getTrapsByPlant(plantID) {
        return await db.traps.where("PlantID").equals(plantID).toArray();
    },

    async getTrapsForLocationByTrapID(trapID) {
        let trap = await db.traps.where("TrapID").equals(trapID).first();
        return await await db.traps.where("LocationID").equals(trap.LocationID).toArray();
    },

    async addTrapInspections(trapInspections) {
        await db.trapInspections.bulkPut(trapInspections);
    },

    async getTrapInspections() {
        return await db.trapInspections.toArray();
    },

    async clearUnsentTrapInspections() {
        await db.trapInspections.where("TrapInspectionDetailID").equals(0).delete();
        return await db.trapInspectionsUnsent.clear();
    },

    async clearTrapLocations() {
        await db.trapLocations.clear();
    },

    async clearTraps() {
        await db.traps.clear();
    },

    async clearTrapInspections() {
        await db.trapInspections.clear();
    },

    async addUnsentTrapInspections(items) {
        return await db.trapInspectionsUnsent.bulkPut(items);
    },

    async getUnsetTrapInspections() {
        return await db.trapInspectionsUnsent.toArray();
    }
}